import * as types from "./actionTypes";

export function set(customModal) {
	return {
		type: types.CUSTOM_MODAL_SET,
		body: customModal
	};
}

export function reset() {
	return {
		type: types.CUSTOM_MODAL_RESET
	};
}